(function() {
  const cookieDomain = '.sportsfuel.co.nz'

  function getSessionScope() {
    return window.theme.auth?.websiteDomain?.includes(cookieDomain) ? cookieDomain : undefined
  }

  supertokens.init({
    appInfo: window.theme.auth,
    recipeList: [
      supertokensEmailPassword.init(),
      supertokensEmailVerification.init(),
      supertokensSession.init({
        sessionScope: getSessionScope(),
      }),
    ],
  });
})();